export const SUPPORT_HUB_GLOBAL_NAV_APP_NAME = "supportHubTwo";
export const DEVELOPER_HUB_GLOBAL_NAV_APP_NAME = "developer";

export const APPLICATION_TAGS = Object.freeze({
  DEVELOPER: "developer_arm_com",
  SUPPORT: "support_arm_com",
});
